(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurora-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  document.documentElement.classList.add('af-js');

  var mq = window.matchMedia('(max-width: 749px)');

  function syncAccordion(root) {
    var isMobile = mq.matches;
    root.querySelectorAll('[data-af-acc]').forEach(function (btn) {
      var col = btn.closest('.af__col');
      if (isMobile) {
        btn.removeAttribute('tabindex');
        btn.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
      } else {
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initAccordion(root) {
    root.querySelectorAll('[data-af-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mq.matches) return;
        var col = btn.closest('.af__col');
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    syncAccordion(root);
    var handler = function () { syncAccordion(root); };
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else if (mq.addListener) mq.addListener(handler);
  }

  function initLocalization(root) {
    root.querySelectorAll('.af__loc select').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initVideo(root) {
    var modal = root.querySelector('[data-af-modal]');
    if (!modal) return;
    var frame = modal.querySelector('[data-af-modal-frame]');
    var embed = modal.getAttribute('data-embed');

    function open() {
      if (typeof modal.showModal !== 'function') {
        window.open(embed, '_blank', 'noopener');
        return;
      }
      frame.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src = embed;
      iframe.title = 'Video player';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.setAttribute('allowfullscreen', '');
      frame.appendChild(iframe);
      modal.showModal();
    }
    function close() { if (modal.open) modal.close(); }

    root.querySelectorAll('[data-af-video-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    modal.querySelector('[data-af-modal-close]').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    modal.addEventListener('close', function () { frame.innerHTML = ''; });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-af-ready')) return;
    root.setAttribute('data-af-ready', '');
    initAccordion(root);
    initLocalization(root);
    initVideo(root);
  }

  function initAll() { document.querySelectorAll('[data-af]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-af]') : null;
    init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      // onixx-search exposes .isOpen too, so the header won't slide away while results are showing
      this.predictiveSearches = this.querySelectorAll('predictive-search, onixx-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
      this.header.querySelectorAll('onixx-search').forEach((search) => search.close && search.close());
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onix-core-7"] && !Shopify.designMode) return;
  try {
    
/* Sticky banner via GSAP ScrollTrigger (desktop only). */
(function () {
  if (window.__bsPinBooted) return;
  window.__bsPinBooted = true;

  var SELECTOR = '[data-bs-sticky]';

  function destroy(section) {
    if (!section || !section._bsPin) return;
    section._bsPin.revert();
    delete section._bsPin;
    section.classList.remove('bs--gsap');
  }

  function init(section) {
    destroy(section);

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var banner = section.querySelector('[data-bs-banner]');
    var products = section.querySelector('[data-bs-products]');
    if (!gsap || !ScrollTrigger || !banner || !products) return;

    gsap.registerPlugin(ScrollTrigger);

    function offset() {
      return parseFloat(section.dataset.stickyOffset) || 0;
    }

    var mm = gsap.matchMedia();

    mm.add('(min-width: 990px)', function () {
      section.classList.add('bs--gsap');

      // Nothing to scroll past if the products are shorter than the banner.
      if (products.offsetHeight <= banner.offsetHeight) return;

      ScrollTrigger.create({
        trigger: products,
        // Pin when the product column reaches the top (minus header offset)...
        start: function () { return 'top top+=' + offset(); },
        // ...and release when the last product row lines up with the banner bottom.
        end: function () { return 'bottom top+=' + (offset() + banner.offsetHeight); },
        pin: banner,
        pinSpacing: false,
        anticipatePin: 1,
        invalidateOnRefresh: true
      });

      return function () { section.classList.remove('bs--gsap'); };
    });

    section._bsPin = mm;
  }

  function findSection(target) {
    if (!target) return null;
    if (target.matches && target.matches(SELECTOR)) return target;
    return target.querySelector(SELECTOR);
  }

  function refresh() {
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  }

  function boot() {
    if (!window.gsap || !window.ScrollTrigger) {
      console.warn('Men new arrivals: GSAP did not load, falling back to CSS sticky.');
      return;
    }

    document.querySelectorAll(SELECTOR).forEach(init);
    window.addEventListener('load', refresh, { once: true });

    // Late-loading fonts or images above this section shift its position.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);

    document.addEventListener('shopify:section:load', function (event) {
      var section = findSection(event.target);
      if (section) init(section);
      refresh();
    });
    document.addEventListener('shopify:section:unload', function (event) {
      destroy(findSection(event.target));
      refresh();
    });
    document.addEventListener('shopify:section:reorder', refresh);
  }

  function wait(attempt) {
    if ((window.gsap && window.ScrollTrigger) || attempt > 100) boot();
    else window.setTimeout(function () { wait(attempt + 1); }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wait(0); });
  } else {
    wait(0);
  }
})();

/* Swatch hover preview. */
(function () {
  if (window.__bsSwatchesBound) return;
  window.__bsSwatchesBound = true;

  function preview(swatch) {
    var card = swatch.closest('[data-bs-card]');
    var img = card && card.querySelector('img.bs-card__img--primary');
    if (!img || !swatch.dataset.src) return;

    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', swatch.dataset.srcset || '');
    img.setAttribute('src', swatch.dataset.src);
    card.classList.add('is-previewing');
  }

  function restore(list) {
    var card = list.closest('[data-bs-card]');
    var img = card && card.querySelector('img.bs-card__img--primary');
    if (!img || img.dataset.origSrc === undefined) return;
    img.setAttribute('srcset', img.dataset.origSrcset);
    img.setAttribute('src', img.dataset.origSrc);
    card.classList.remove('is-previewing');
  }

  function onEnter(event) {
    var swatch = event.target.closest && event.target.closest('[data-bs-swatch]');
    if (swatch) preview(swatch);
  }

  function onLeave(event) {
    var list = event.target.closest && event.target.closest('[data-bs-swatches]');
    if (list && !list.contains(event.relatedTarget)) restore(list);
  }

  // position: sticky stops working inside any ancestor with overflow
  // hidden/auto/scroll. Switch those ancestors to overflow: clip, which clips
  // the same way but keeps sticky working.
  function unblockSticky() {
    if (!window.CSS || !CSS.supports('overflow', 'clip')) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('.bs').forEach(function (section) {
      var el = section.parentElement;
      while (el) {
        var cs = window.getComputedStyle(el);
        var x = cs.overflowX;
        var y = cs.overflowY;
        if (x !== 'visible' && x !== 'clip') el.style.overflowX = 'clip';
        if (y === 'hidden') {
          el.style.overflowY = 'clip';
        } else if (y === 'auto' || y === 'scroll') {
          // overflow-x: hidden forces overflow-y to compute as auto; restore visible.
          el.style.overflowY = x !== 'visible' ? 'visible' : 'clip';
        }
        if (el === document.documentElement) break;
        el = el.parentElement;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', unblockSticky);
  } else {
    unblockSticky();
  }
  window.addEventListener('load', unblockSticky);
  document.addEventListener('shopify:section:load', unblockSticky);

  document.addEventListener('mouseover', onEnter);
  document.addEventListener('mouseout', onLeave);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('focusout', onLeave);
})();

  } catch(e) { console.error(e); }
})();
})();
